import React, { FC } from 'react'
import styles from './PhoneNumberField.module.scss'

import classNames from 'classnames'
import { useField } from 'formik'
import { Country } from 'api/countries/getCountriesList'
import { User } from 'interfaces'
import { CountryCodeSelector } from '../CountryCodeSelector/CountryCodeSelector'

interface Props {
  label: string
  id: string
  placeholder: string
  onCountrySelected: (country: Country) => void
  currentUser?: User
  isValid: boolean
  validationMessage?: string
  isRequired?: boolean
}
export const PhoneNumberField: FC<Props> = ({
  label,
  id,
  placeholder,
  onCountrySelected,
  currentUser,
  isValid,
  validationMessage,
  isRequired
}) => {
  const [field, meta] = useField(id)
  const showError = !isValid && validationMessage
  return (
    <div className={styles.PhoneNumberField}>
      <label
        htmlFor={id}
        className={classNames(styles.Label, { [styles.ErrorLabel]: showError })}
      >
        {showError ? validationMessage : label + ' '}
        {isRequired && ' *'}
      </label>
      <div
        className={classNames(styles.FieldContainer, {
          [styles.Error]: meta.error && meta.touched
        })}
      >
        <CountryCodeSelector
          onCountrySelected={(country: Country) => onCountrySelected(country)}
          currentUser={currentUser}
        />
        <input
          className={styles.PhoneNumberField}
          placeholder={placeholder}
          data-testid="phone-number-field"
          id={id}
          {...field}
        />
      </div>
    </div>
  )
}
